import React, { useContext } from 'react';
import { Context as CountriesContext } from '../context/CountriesContext';
import numeral from 'numeral';
import { Paper } from '@material-ui/core';
import { sortCountries } from '../utils/';
import '../styles/Table.css';

function Table() {
  const { state } = useContext(CountriesContext);
  const sortedCountries = sortCountries(state.countries);

  return (
    <Paper className="table">
      <h2 className="table__title">Live Cases by Country</h2>
      <table className="table__table">
        <thead className="table__header">
          <tr>
            <td>Flag</td>
            <td>Rank</td>
            <td>Country</td>
            <td>Total Cases</td>
          </tr>
        </thead>
        <tbody>
          {sortedCountries.map(({ country, countryInfo, cases }, index) => (
            <tr key={`${countryInfo._id}-table-row-${index}`}>
              <td
                className="table__flag"
                style={{
                  backgroundImage: `url(${countryInfo.flag})`
                }}></td>
              <td>{index + 1}</td>
              <td>{country}</td>
              <td>{numeral(cases).format('0,0')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Paper>
  );
}

export default Table;
